// extracted by mini-css-extract-plugin
export var box = "_4a-0";
export var check = "_4a-1";
export var checkboxButton = "_4a-6";
export var checkboxGroup = "_4a-5";
export var disabled = "_4a-7";
export var ghost = "_4a-9";
export var input = "_4a-2";
export var label = "_4a-4";
export var normal = "_4a-8";
export var uncheck = "_4a-3";